import { createSearchModel } from './model.js';
import { erpUserInfoReady } from '@/pages/login/servers.js';
import { getTradeSearch, getShopList, getTradeSearchCount } from '@api/trade';
import { getTradeIndexInfo, tradeConfigInfoNew, tradeConfigUpdateNew } from '@api/trade/orderSettings.js';
// import { getShopList } from '@servers/base/shop/index.js';
import { dwTableList } from '@/pages/distributor/trade/order/audit/table/service/service.table.help.js';
import { getExpressTemplateList, getTradeTagList, queryDmsDistributorInfoList, getTradeSearchCustomList, getLogisticsStatisticsSids } from '@api/trade/audit.js';
import {
  GET_TRADE_SEARCH,
  SET_AUDIT_TABLE_DATA,
  SET_PAGINATION_MODEL,
  GET_TRADE_TAG_LIST,
  SET_TRADE_TAG_LIST,
  GET_DICTIONARY_DATA,
  SET_DICTIONARY_DATA,
  GET_TRADE_SEARCH_CUSTOM_LIST,
  SET_TRADE_SEARCH_CUSTOM_LIST,
  GET_CUSTOM_EXCEPTION,
  GET_TRADE_SETTINGS,
  SET_TRADE_SETTINGS,
  GET_TRADE_SETTINGS_NEW,
  SET_TRADE_SETTINGS_NEW,
  SET_SEARCH_MODEL,
  GET_TRADE_SEARCH_COUNT,
  GET_LIST_GOODSINFO_SETTINGS,
  SET_LIST_GOODSINFO_SETTINGS,
  GET_TRADE_PAGESIZE,
  SET_TRADE_PAGESIZE,
  SET_AUDIT_STATUS_COUNT,
  GET_AUDIT_STATUS_COUNT,
  SET_LIST_KEEP_LAST_RENDER_INDEX,
} from './types';

const lock = {
  value: false,
  setTrue: function () {
    this.value = true;
  },
  setFalse: function () {
    this.value = false;
  },
};

const logisticsWarningNeedFetch = {
  value: false,
  ids: [],
  setTrue() {
    this.value = true;
  },
  setFalse() {
    this.value = false;
  },
  setIds(v) {
    this.ids = v
  }
}

export default {
  // 获取列表
  async [GET_TRADE_SEARCH]({ getters, state, commit, dispatch }, {checkedSids = [], _from, _keepLastRenderIndex = false} = {}) {
    // 如果为true 则代表请求已锁
    if (lock.value) {
      return;
    }
    commit(SET_LIST_KEEP_LAST_RENDER_INDEX, false);
    if (_keepLastRenderIndex) {
      commit(SET_LIST_KEEP_LAST_RENDER_INDEX, true);
    }

    if (['quickSearch', 'baseSearch', 'statusSearch', 'errorStatus', 'clear'].includes(_from)) {
      logisticsWarningNeedFetch.setIds([]);
      _globel_vm.$bus.$emit("updateLogisticsStatistics", {resetValue: true});
      commit(SET_SEARCH_MODEL, {logisticsWarningParams: null})
    } else if (_from === 'eas') {
      _globel_vm.$bus.$emit("tradeQuickSearch", {actionType: 'clear'})
      logisticsWarningNeedFetch.setTrue();
      commit(SET_SEARCH_MODEL, {
        ...createSearchModel(),
        queryId: getters.getSearchParams.queryId,
        logisticsWarningParams: getters.getSearchParams.logisticsWarningParams,
      })
    };



    // 锁住
    lock.setTrue();
    const { pageNo, pageSize } = state.paginationModel;
    try {
      let searchParams = getters.getSearchParams;
      if (searchParams.logisticsWarningParams && logisticsWarningNeedFetch.value) {
        logisticsWarningNeedFetch.setFalse();
        // 物流预警参数需要调接口转为sid
        let lwpCurrentNum = searchParams.logisticsWarningParams.currentNum;
        delete searchParams.logisticsWarningParams.currentNum;
        const lsidsRes = await getLogisticsStatisticsSids({
          queryId: searchParams.queryId,
          ...searchParams.logisticsWarningParams
        });
        let lsids = (lsidsRes.data || []).map(s => String(s));
        if (lwpCurrentNum !== lsids.length) {
          // 需更新预警数据
          _globel_vm.$bus.$emit('updateLogisticsStatistics', {
            key: searchParams.logisticsWarningParams.logisticsWarningType,
            warningTypeInterval: searchParams.logisticsWarningParams.warningTypeInterval,
            changeNum: lsids.length - lwpCurrentNum
          })
        }

        logisticsWarningNeedFetch.setIds(lsids);
        delete searchParams.logisticsWarningParams;
        
        if (!lsids.length) {
          commit(SET_AUDIT_TABLE_DATA, dwTableList([], checkedSids));
          commit(SET_PAGINATION_MODEL, { total: 0 });
          lock.setFalse();
          return;
        }
      }

      let searchP = getters.getSearchParams;

      let newSid = (searchP.sid || '').split(',').filter(sid => sid !== '').concat(logisticsWarningNeedFetch.ids);
      searchP.sid = Array.from(new Set(newSid)).join(',')


      const { total = 0, list = [], ifNeedCount } = await getTradeSearch({
        useHasNext: 1,
        pageNo,
        pageSize,
        ...searchP,
        needAllocateStock: 0,
        _sys_from: 'scm',
      });

      if (ifNeedCount !== false) {
        dispatch(GET_TRADE_SEARCH_COUNT, {searchParams: {
          pageNo,
          pageSize,
          ...searchP,
          needAllocateStock: 0,
        }})
      } else {
        commit(SET_PAGINATION_MODEL, { total });
      }
      commit(SET_AUDIT_TABLE_DATA, dwTableList(list, checkedSids));
      lock.setFalse();
    } catch (error) {
      lock.setFalse();
    }
  },
  // 获取此次查询条件的总数量
  async [GET_TRADE_SEARCH_COUNT]({commit}, {searchParams} = {}) {
    const { total } = await getTradeSearchCount(searchParams);
    commit(SET_PAGINATION_MODEL, { total });
  },
  // 审核状态数量统计
  async [GET_AUDIT_STATUS_COUNT]({commit}, {searchParams} = {}) {
    const { queryId } = searchParams;
    try {
      const [{ total: t1 }, { total: t2 }] = await Promise.all([getTradeSearchCount({
        queryId, isExcep: 0,
        sysStatus: 'WAIT_AUDIT',
        excludeTradeType: '75,48',
      }), getTradeSearchCount({
        queryId, isExcep: 0,
        sysStatus: 'WAIT_AUDIT',
        tradeType: '75,48',
      })])
      commit(SET_AUDIT_STATUS_COUNT, {
        WAIT_AUDIT: t1,
        WAIT_AUDIT_75: t2,
      })
    } catch (error) {
      commit(SET_AUDIT_STATUS_COUNT, {
        WAIT_AUDIT: 0,
        WAIT_AUDIT_75: 0,
      })
    }
  },

  // 获取标签
  async [GET_TRADE_TAG_LIST]({ commit }) {
    const res = await getTradeTagList({ kind: 0 });
    commit(SET_TRADE_TAG_LIST, res?.data || []);
  },
  // 数据集合
  async [GET_DICTIONARY_DATA]({ dispatch, commit, rootState }, { shopParams = {} } = {}) {
    // 获取参数
    await erpUserInfoReady;
    const companyId = rootState?.user?.userInfo?.companyId || '';
    const shopTotal = rootState?.user?.erpUserInfo?.shopTotal || 200;

    const list = await getShopList(shopTotal);
    const { expressCompanies = [] } = await getExpressTemplateList({ containElectronic: true });
    const { distributorList = [], supplierList = [] } = await queryDmsDistributorInfoList({ companyId });
    // 获取自定义异常
    dispatch(GET_CUSTOM_EXCEPTION);
    // update
    commit(SET_DICTIONARY_DATA, {
      shopList: list,
      supplierList,
      expressCompanies,
      distributorList,
    });
  },
  async [GET_CUSTOM_EXCEPTION]({ commit }) {
    // 获取自定义异常
    const { data = [] } = await getTradeTagList({ kind: 1, ignoreUnattainable: 1 });

    // 获取后端定义死的快递异常
    // 及暂停发货异常
    const thirdWarehouseExceptIds = ['2000000004', '2000000003', '2000000002', '2000000001'] // 三方仓异常需要展示（停发、创建、重建、取消）
    const expressException = data.filter(item => !item.allowUpdate && ['17', '4000000000', ...thirdWarehouseExceptIds].includes(item.id));
    console.log(expressException, '----expressException');

    // update
    commit(SET_DICTIONARY_DATA, {
      customExceptionList: expressException.concat(data.filter(item => item.allowUpdate)),
    });
  },
  // 获取快捷查询
  async [GET_TRADE_SEARCH_CUSTOM_LIST]({ commit, getters }) {
    const { data = [] } = await getTradeSearchCustomList({ queryId: getters.getCurrentTabQueryId });
    commit(SET_TRADE_SEARCH_CUSTOM_LIST, data);
  },
  // 获取系统配置交易配置
  async [GET_TRADE_SETTINGS]({ commit }) {
    const { config = {} } = await getTradeIndexInfo();
    const { orderImageSource = 0, showSkuProperties = 0, chatConfigs = '{}' } = config;
    commit(SET_TRADE_SETTINGS, {
      orderImageSource,
      showSkuProperties,
      chatConfigs: JSON.parse(chatConfigs),
    });
  },
  // 获取系统配置交易新版配置
  async [GET_TRADE_SETTINGS_NEW]({ commit }) {
    const config = await tradeConfigInfoNew();
    commit(SET_TRADE_SETTINGS_NEW, config || {});
  },
  // 获取列表商品信息展示配置
  async [GET_LIST_GOODSINFO_SETTINGS]({ commit, state }) {
    let res = await window.COMMON_STORAGE_CONF.get(state.goodsInfoShow.key);
    if (res?.id) {
      commit(SET_LIST_GOODSINFO_SETTINGS, res);
    }
  },
  async [SET_LIST_GOODSINFO_SETTINGS]({ commit, state }, data = {}) {
    let params = {
      ...state.goodsInfoShow,
      value: {
        ...data
      }
    }
    commit(SET_LIST_GOODSINFO_SETTINGS, params);
    try {
      const config = await window.COMMON_STORAGE_CONF.set(params);
      commit(SET_LIST_GOODSINFO_SETTINGS, config);
    } catch (error) {
      
    }
  },
  // 获取列表pageSize
  [GET_TRADE_PAGESIZE]({ commit, state }) {
    return new Promise(async (r, re) => {
      try {
        let res = await window.COMMON_STORAGE_CONF.get(state.pageSizeRemote.key);
        if (res?.id) {
          commit(SET_TRADE_PAGESIZE, res);
        }
        r()
      } catch (error) {
        re(error)
      }
    })
  },
  async [SET_TRADE_PAGESIZE]({ commit, state, getters }, pageSize) {
    const key = getters.getCurrentTabKey;
    let params = {
      ...state.pageSizeRemote,
    }
    params.value[key] = pageSize;
    commit(SET_TRADE_PAGESIZE, params);
    try {
      const config = await window.COMMON_STORAGE_CONF.set(params);
      commit(SET_TRADE_PAGESIZE, config);
    } catch (error) {
      
    }
  },
};
